/* KALIÄ · Rediseño 2026 */
(function(){
  function toast(html){
    var t=document.querySelector('.k-toast');
    if(!t){t=document.createElement('div');t.className='k-toast';t.setAttribute('role','status');t.setAttribute('aria-live','polite');document.body.appendChild(t);}
    t.innerHTML=html;
    requestAnimationFrame(function(){t.classList.add('is-visible');});
    clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('is-visible');},3800);
  }
  function refreshBubble(){
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'?sections=cart-icon-bubble').then(function(r){return r.json();}).then(function(s){
      var el=document.getElementById('cart-icon-bubble');
      if(!el||!s['cart-icon-bubble'])return;
      var d=new DOMParser().parseFromString(s['cart-icon-bubble'],'text/html');
      var n=d.querySelector('.shopify-section');
      el.innerHTML=n?n.innerHTML:d.body.innerHTML;
    }).catch(function(){});
  }
  function closePanel(b){
    var card=b.closest('.k-card');if(!card)return;
    var p=card.querySelector('.k-qa');var tg=card.querySelector('.k-qa-toggle');
    if(p)p.classList.remove('is-open');if(tg)tg.setAttribute('aria-expanded','false');
  }
  document.addEventListener('click',function(e){
    var tg=e.target.closest('.k-qa-toggle');
    if(tg){
      var p=document.getElementById(tg.getAttribute('aria-controls'));
      var open=tg.getAttribute('aria-expanded')==='true';
      tg.setAttribute('aria-expanded',String(!open));
      if(p)p.classList.toggle('is-open',!open);
      return;
    }
    var b=e.target.closest('[data-k-add]');
    if(!b||b.disabled)return;
    e.preventDefault();
    b.classList.add('is-loading');
    var cn=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
    var fd=new FormData();
    fd.append('id',b.getAttribute('data-k-add'));
    fd.append('quantity','1');
    var useCn=!!(cn&&typeof cn.getSectionsToRender==='function'&&typeof cn.renderContents==='function');
    if(useCn){
      fd.append('sections',cn.getSectionsToRender().map(function(s){return s.id;}));
      fd.append('sections_url',window.location.pathname);
      if(typeof cn.setActiveElement==='function')cn.setActiveElement(b);
    }
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:fd})
      .then(function(r){return r.json();})
      .then(function(j){
        b.classList.remove('is-loading');
        closePanel(b);
        if(j.status){toast(j.description||j.message||'No se pudo agregar');return;}
        if(useCn&&j.sections){cn.renderContents(j);}
        else{toast('Agregado al carro <a href=/cart>Ver carro</a>');refreshBubble();}
      })
      .catch(function(){b.classList.remove('is-loading');toast('No se pudo agregar. Intenta de nuevo.');});
  });
  function initRails(root){
    (root||document).querySelectorAll('[data-k-rail]').forEach(function(w){
      if(w._k)return;w._k=1;
      var r=w.querySelector('.k-rail');if(!r)return;
      var pv=w.querySelector('.k-arrow--prev'),nx=w.querySelector('.k-arrow--next');
      var upd=function(){if(pv)pv.disabled=r.scrollLeft<4;if(nx)nx.disabled=r.scrollLeft+r.clientWidth>=r.scrollWidth-4;};
      var step=function(){return r.clientWidth*.85;};
      if(pv)pv.addEventListener('click',function(){r.scrollBy({left:-step(),behavior:'smooth'});});
      if(nx)nx.addEventListener('click',function(){r.scrollBy({left:step(),behavior:'smooth'});});
      r.addEventListener('scroll',upd,{passive:true});
      window.addEventListener('resize',upd);
      upd();w._upd=upd;
    });
  }
  function initTabs(root){
    (root||document).querySelectorAll('[data-k-tabs]').forEach(function(t){
      if(t._k)return;t._k=1;
      var btns=t.querySelectorAll('[role=tab]');
      btns.forEach(function(b){
        b.addEventListener('click',function(){
          btns.forEach(function(x){
            var on=x===b;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;
            var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on;
          });
          var pnl=document.getElementById(b.getAttribute('aria-controls'));
          var w=pnl&&pnl.querySelector('[data-k-rail]');if(w&&w._upd)w._upd();
        });
      });
    });
  }
  function init(root){initRails(root);initTabs(root);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init();});}else{init();}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
